window.MM = window.MM || {};

MM.closeQuickView = function () {
    document.body.classList.remove('quick-view-show');
};

MM.initTrustSlider = function () {

    const slider = document.querySelector('.mm-cart-trust-slider');

    if (!slider) return;

    if (slider.swiper) {
        slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {
        slidesPerView: 'auto',
        loop: true,
        speed: 4000,
        spaceBetween: 30,
        allowTouchMove: false,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        }
    });

    console.log('Trust slider initialized');
};

MM.cartRecommendations = {
    productId: null,
    cache: new Map(),
    swiper: null,

    init: function () {
        const container = document.querySelector(
            '[data-mm-cart-recommendations]'
        );

        if (!container) {
            return;
        }

        const productContext = document.querySelector(
            '[data-mm-product-context]'
        );

        if (!productContext) {
            this.hide(container);
            return;
        }

        const productId = productContext.dataset.productId;

        if (!productId) {
            this.hide(container);
            return;
        }

        this.productId = productId;

        if (this.cache.has(productId)) {
            this.render(
                container,
                this.cache.get(productId)
            );

            return;
        }

        this.load(container, productId);
    },

    load: async function (container, productId) {
        try {
            const url = new URL(
                window.Shopify.routes.root + 'recommendations/products',
                window.location.origin
            );

            url.searchParams.set(
                'section_id',
                'mm-cart-recommendations'
            );

            url.searchParams.set(
                'product_id',
                productId
            );

            url.searchParams.set(
                'limit',
                '8'
            );

            url.searchParams.set(
                'intent',
                'related'
            );

            const response = await fetch(url.toString());

            if (!response.ok) {
                throw new Error(
                    `Recommendations request failed: ${response.status}`
                );
            }

            const html = await response.text();

            this.cache.set(productId, html);

            this.render(container, html);

        } catch (error) {
            console.error(
                '[MM Cart Recommendations]',
                error
            );

            this.hide(container);
        }
    },

    render: function (container, html) {
        const temp = document.createElement('div');

        temp.innerHTML = html;

        const content = temp.querySelector(
            '[data-mm-cart-recommendations-content]'
        );

        if (!content) {
            this.hide(container);
            return;
        }

        container.innerHTML = '';
        container.appendChild(content);
        container.hidden = false;

        this.initSlider();
    },

    hide: function (container) {
        container.hidden = true;
        container.innerHTML = '';

        this.destroySlider();
    },

    initSlider: function () {
        const slider = document.querySelector(
            '.mm-cart-recommendations__slider'
        );

        if (!slider || typeof Swiper === 'undefined') {
            return;
        }

        this.destroySlider();

        this.swiper = new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: {
                enabled: true,
                momentum: true,
                momentumBounce: false
            },
            grabCursor: true,
            watchOverflow: true,
            navigation: {
                nextEl: '.mm-cart-recommendations__next',
                prevEl: '.mm-cart-recommendations__prev'
            }
        });
    },

    destroySlider: function () {
        if (
            this.swiper &&
            typeof this.swiper.destroy === 'function'
        ) {
            this.swiper.destroy(true, true);
        }

        this.swiper = null;
    }
};

MM.initCart = function () {
    MM.initTrustSlider();
    MM.cartRecommendations.init();
};